/* .custom_btn {
    background-color: var(--main-color);
    font-size: 14px;
    font-weight: 500;
    border: 0;
    border-radius: 50px;
    padding: 1px 12px;
    line-height: 35px;
    min-width: 100px;
    outline: none;
}

.custom_btn .btn_icon_container {
    color: #000;
    background: #fff;
    border-radius: 50px;
    height: 27px;
    width: 27px;
    line-height: 29px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
}

.custom_btn .btn_icon_container > .MuiSvgIcon-root {
    font-size: 16px;
}

.custom_btn .btn_text {
    font-size: 14px;
    text-transform: none;
    text-align: center;
    width: 100%;
    margin-left: 5px;
    margin-right: 5px;
}
 */

import {makeStyles} from '@material-ui/core';

const useStyles = makeStyles (theme => ({
  customBtn: {
    backgroundColor: '#808d9f',
    fontSize: 14,
    border: 0,
    borderRadius: 50,
    padding: '3px 15px',
    minWidth: 100,
    outline: 'none',
    fontWeight: 500,
    "&:hover": {
      backgroundColor: "#808d9f"
    }
  },
  btnIcon: {
    color: "#808d9f",
    background: "#2d3748",
    borderRadius: 50,
    height: 27,
    width: 27,
    lineHeight: 29,
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  btnText: {
    fontSize: 14, 
    textTransform: "none",      
    textAlign: "center",
    width: "100%",
    marginLeft: 5,
    marginRight: 5,
    color: "#2d3748",
  }

}));

export default useStyles;
